export class SendResetPasswordMailRequestModel {
    constructor() {
        this.email = "";
    }
}
export default class SendResetPasswordMailRequest extends SendResetPasswordMailRequestModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
